import type { SortDirection } from '@tanstack/react-table';

import { OrderDirection } from '@repo/frontend-shared';

/**
 * Converts TanStack Table's SortDirection to GraphQL OrderDirection
 * TanStack uses lowercase 'asc' | 'desc' | false
 * GraphQL uses uppercase 'ASC' | 'DESC'
 */
export function tanStackSortToOrderDirection(sort: SortDirection | false): OrderDirection | false {
  if (sort === false) return false;
  return sort === 'asc' ? OrderDirection.ASC : OrderDirection.DESC;
}

/**
 * Converts GraphQL OrderDirection to TanStack Table's SortDirection
 */
export function orderDirectionToTanStackSort(direction: OrderDirection): SortDirection {
  return direction === OrderDirection.ASC ? 'asc' : 'desc';
}
